import React, {useEffect, useState} from 'react';
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";
import {InteractionArea} from "../../../types/InteractionArea";

type DeleteInteractionAreaProps = {
    interactionArea: InteractionArea | null
    show: boolean
    onDelete?: (site: InteractionArea) => any
    onDeleteFail?: (site: InteractionArea, error: unknown) => any
    onCancel?: () => any
}

function DeleteInteractionArea(props: DeleteInteractionAreaProps) {
    const {interactionArea, show, onDelete, onDeleteFail, onCancel} = props

    const {notify} = useNotifications()

    const [name, setName] = useState<string>(interactionArea?.name || `this interaction area`);
    const {mutateAsync: deleteInteractionArea} = useMutation(ngage.interactionAreas.destroy)

    useEffect(() => {
        if(interactionArea) setName(interactionArea.name)
    }, [interactionArea]);

    async function handleDelete() {
        if (interactionArea) {
            try {
                await deleteInteractionArea(interactionArea.id)
                await invalidate('interaction-areas.all')

                notify("success", 'Interaction Area Deleted', `${interactionArea.name} has been permanently removed`)
                if (onDelete) onDelete(interactionArea)
            } catch (error) {
                notify("error", 'Interaction Area Not Deleted', `${interactionArea.name} could not be removed`)
                if (onDeleteFail) onDeleteFail(interactionArea, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title={`Delete Interaction Area`}
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDelete}
            onCancel={handleCancel}
        />
    );
}

export default DeleteInteractionArea;